import { lazy } from 'react';
//import General from "../pages/Ledgers/General";

const General = lazy(() => import('../pages/Ledgers/General'));

const generalLedgerRoute = {
  public: [],
  auth: [
    {
      name: 'general_ledger',
      path: '/finance-and-accounting/general-ledger',
      component: General,
    },
  ],
};

export default generalLedgerRoute;
